<template>

	<!-- Information Card 2 -->
	<a-card :bordered="false" class="card-info-2 h-full">
		<div class="col-content h-full" style="background-image: url('images/info-card-2.jpg')">
			<div class="card-content">
				<h5>با بهترین ها کار کنید </h5>
				<p>خلق ثروت یک بازی با جمع مثبت تکاملی اخیر است. همه چیز به این بستگی دارد که چه کسی اول از فرصت استفاده می کند.</p>
			</div>
			<div class="card-footer">
				<a href="#" size="small">
					
					<span>بیشتر بخوانید</span>
					
				</a>
			</div>
		</div>
	</a-card>
	<!-- / Information Card 2 -->

</template>

<script>

	export default ({
		data() {
			return {
			}
		},
	})

</script>